function c(r) {
  return r.type === "group";
}
function o(r) {
  return r.type === "ignored";
}
function g(r, t) {
  try {
    return !!(1 + t.toString().toLowerCase().indexOf(r.trim().toLowerCase()));
  } catch (f) {
    return !1;
  }
}
function p(r, t) {
  return {
    getIsGroup: c,
    getIgnored: o,
    getKey(e) {
      return c(e) ? e.name || e.key || "key-required" : e[r];
    },
    getChildren(e) {
      return e[t];
    }
  };
}
function h(r, t, f, e) {
  if (!t)
    return r;
  function n(s) {
    if (!Array.isArray(s))
      return [];
    const a = [];
    for (const u of s)
      if (c(u)) {
        const i = n(u[e]);
        i.length && a.push(Object.assign({}, u, {
          [e]: i
        }));
      } else {
        if (o(u))
          continue;
        t(f, u) && a.push(u);
      }
    return a;
  }
  return n(r);
}
function y(r, t, f) {
  const e = /* @__PURE__ */ new Map();
  return r.forEach((n) => {
    c(n) ? n[f].forEach((s) => {
      e.set(s[t], s);
    }) : e.set(n[t], n);
  }), e;
}
export {
  p as createTmOptions,
  y as createValOptMap,
  h as filterOptions,
  o as getIgnored,
  c as getIsGroup,
  g as patternMatched
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/select/src/utils.js
// module id = 492
// module chunks = 67